import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the shared block editor a crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/shared-blocks')({
  staticData: { crumb: 'common:nav.sharedBlocks' },
  component: Outlet,
});
